import { TagProps } from 'antd';
import { capitalize } from 'lodash-es';
import { memo } from 'react';
import { toUpperCase } from 'utils/toLowerCase';
import { BlueTag, GreenTag, RedTag, BlackTag } from './styled/tags';

export interface PlatformTagProps extends TagProps {
  platform: General.CaselessPlatformTunnel;
}

const PlatformTag = (props: PlatformTagProps) => {
  const { platform, ...tagsProps } = props;
  const upperPlatform = toUpperCase(platform);
  const capital = capitalize(platform === 'WA_BIZ' ? 'WhatsApp' : platform);

  switch (upperPlatform) {
    case 'SHOPEE': {
      return <RedTag {...tagsProps}>{capital}</RedTag>;
    }
    case 'LAZADA': {
      return <BlueTag {...tagsProps}>{capital}</BlueTag>;
    }
    case 'TIKTOK':
    case 'TIKTOK_US': {
      return <BlackTag {...tagsProps}>{capital}</BlackTag>;
    }
    default: {
      return <GreenTag {...tagsProps}>{capital}</GreenTag>;
    }
  }
};
export default memo(PlatformTag);
